export const USER_GUIDE_DOC_URL =
  "https://docs.google.com/document/d/1DrJW5eU5A1gjkItTiO7d82CDw22P_JPxPTb26RpEbsA/edit?usp=sharing";

export const LOGIN_WARNING_TUTORIAL_DOC_URL =
  "https://docs.google.com/document/d/1L5nqZXnGy4EpmBZSMkRjqQEYT5Xr-nOXUasHU5WKx3Y/edit?usp=sharing";

export const VERSION_UPDATE_TUTORIAL_DOC_URL =
  "https://docs.google.com/document/d/1Cn6Vg5pnypyUznaOea58VzJEtiOj_Oh6_2GBEVCQ-cU/edit?usp=sharing";

export const TUTORIALS_YOUTUBE_PLAYLIST_URL =
  "https://www.youtube.com/playlist?list=PL3Stb_ZYMxUL3H_99LuVZGJZbIMJpRTNq";

export const USER_MANUAL_URL =
  "https://drive.google.com/drive/folders/1gIGtIjFRkdqiuLTe8s6F62JZOXqoMWqX?usp=sharing";

export const CONTROLLER_PAIRING_VIDEO_URL = "https://youtu.be/mbVEjrJWsiE?si=HrtxTQHVvl-PDohv";

export const CONFIGURE_PERMISSIONS_VIDEO_URL = "https://youtu.be/Hf8UZ-rPQ7c";

export const DISTRIBUTOR_DOCS_FOLDER_URL =
  "https://drive.google.com/drive/folders/1qTW7hOk_Udiq4XYLAMyRljbqUb6LhalP?usp=sharing";
